export default __webpack_public_path__ + "static/media/doug-404.70bdc2bc.png";